export const SECURITY_BASE_PATH = '/mpoc/security';

export function getAppBasePath(pathname = window.location.pathname) {
    return pathname === SECURITY_BASE_PATH || pathname.startsWith(`${SECURITY_BASE_PATH}/`)
        ? SECURITY_BASE_PATH
        : '';
}

export function appPath(path) {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${getAppBasePath()}${normalized}`;
}
